import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Sponsors from '../components/Sponsors';
import MenuBogota from '../components/MenuBogota';
import MenuItineraryBogota from '../components/MenuItineraryBogota';
import '../assets/styles/containers/SimpleSection.sass';

class SimpleSectionBogota extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      data: {},
    }
  }
  
  componentDidMount() {
    const {slug} = this.props.match.params;
    this.getData(slug);
  }

  componentWillReceiveProps(nextProps) {
    const {slug} = this.props.match.params;
    if(slug !== nextProps.match.params.slug) {
      this.getData(nextProps.match.params.slug);
    }
 }

  getData(slug) {
    fetch(`${process.env.REACT_APP_URL}/api/adventures/general/volcano-mtb/${slug}`)
    .then(res => res.json())
    .then(
      (res) => {
        this.setState({data: res});
      },
      (error) => {
        this.setState({error: error});
      }
    )
    return;
  }
    
  render() {
    const {data} = this.state;
    const {content, sponsors} = data;

    return (
      <Layout>
        <>
          <Banner id={61} city="volcano" thumb="logo_adventures.png"/>
          <MenuBogota />
          {this.props.itinerary &&
            <MenuItineraryBogota />
          }
          <div className="row content-min-height itinerary --bogota">
            {ReactHtmlParser(content?.content_es)}
          </div>
          {sponsors && (
            <Sponsors
              items={sponsors}
              city="bogota"
            />
          )}
        </>
      </Layout>
    );

  }
}

export default SimpleSectionBogota;
